import React, { Component } from 'react';

import { getText } from 'misc/helpers';

class Loader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false
        };

        setTimeout(
            function() {
                this.setState({ showLoader: true });
            }.bind(this),
            200
        );
    }

    render = () => {
        const { objectToLoad } = this.props;

        let content = '';

        // Show content immediately if nothing to load

        content = this.props.children;

        return (
            <div className="loader-container fill-parent">
                {this.showLoaderOrNot(objectToLoad) ? (
                    <div className="loader">
                        <div className="loader-content">
                            <div className="loader-logo">
                                <img src="assets/images/digimail_logo_yellow.svg" className="logo" width="164" height="21" alt="Digimail" />
                            </div>

                            <img src="assets/images/loader_spinner.svg" className="animation-spin" alt="" />
                            <p>{getText('Missing', 'Hämtar information...')}</p>
                        </div>
                    </div>
                ) : (
                    <div className="animation-fade-in fill-parent">{content}</div>
                )}
            </div>
        );
    };

    showLoaderOrNot(objectToLoad) {
        return objectToLoad && this.state.showLoader && objectToLoad.isLoading;
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Loader.js